import founder from "@/assets/optimized-images/founder.png";
import founder2 from "@/assets/optimized-images/egbapics.jpg";
import Button from "../../../components/shared/Button";

const AboutFounder = () => {
  return (
    <>
      <div className="bg-[#e3e8ff87] p-2 sm:pt-2 sm:px-20 pt-20 flex gap-5 flex-col sm:flex-row  font-[Inter]">
        <div className="w-full h-[50%]">
          <img src={founder} alt={founder} className=" w-full" />
        </div>
        <div className="space-y-6 w-full">
          <div className="h-1 w-16 bg-[#3b76db]"></div>
          <h2 className="font-[Tangerine] text-[#041a30] text-4xl sm:text-7xl font-extrabold sm:w-72 leading-9 drop-shadow-2xl">
            About Our Founder
          </h2>
          <p>
            <b>TAJUDEEN OSUDE YUSUF,</b> A Visionary in Quranic Education &
            Digital Learning the founder of Maqrahaat ul Tanzeel, is a
            passionate educator dedicated to making Quran memorization and
            Qira’at mastery accessible to Muslims worldwide.
          </p>
          <p>
            His vision is to empower Muslims globally with the knowledge of the
            Quran, ensuring they not only memorize it with ease but also recite
            it beautifully using various Qira’at styles. He believes that
            learning the Quran should be a structured, engaging, and spiritually
            fulfilling journey for every Muslim.
          </p>

          <p>
            {" "}
            “The Quran is the key to true success—both in this life and the
            hereafter. My goal is to make it accessible to everyone, anywhere,
            anytime.” – Hafiz Tajudeen Yusuf
          </p>
          <a target="_blank" href="https://www.facebook.com/maqrahatultanzeel/">
            <Button
              btnText={"Connect with him on Facebook"}
              btnBgColor={
                "bg-[#66b2ff] hover:bg-white sm:rounded-full hover:rounded-full hover:border hover:border-[#333333]"
              }
              btnColor={"text-white hover:text-[#333333]"}
              padding={"px-5 py-2 transition-all  ease-in-out"}
            />
          </a>
        </div>
      </div>
      <div className="bg-[#e3e8ff87] p-2 sm:pt-2 sm:px-20 pt-20 flex gap-5 flex-col sm:flex-row-reverse ">
        <div className="w-full h-[50%]">
          <img src={founder2} alt={founder2} className=" w-full" />
        </div>
        <div className="space-y-6 w-full">
          <div className="h-1 w-16 bg-[#3b76db]"></div>
          <h2 className="font-[Tangerine] text-4xl sm:text-7xl text-[#041a30] font-extrabold sm:w-80 leading-10 drop-shadow-2xl">
            About Our Co-Founder
          </h2>
          <p>
            Qori & Muqri Abu Malik Abdul Qudus, A Master of Qira’at & Quranic,
            the esteemed co-founder of Maqrahaat ul Tanzeel, is a renowned
            expert in Qira’at, Tajweed, and Quranic Sciences. With over a decade
            of dedication to the study and teaching of the Quran, he has helped
            countless students master Quran memorization and recitation with
            precision and excellence.
          </p>
          <p>
            <b>His Expertise & Contributions</b>
          </p>
          <ul className="list-disc ms-5">
            <li>
              <b>He's Certified in All 10 Qira’at & 20 Riwayaat</b>
            </li>{" "}
            <br />
            <li>
              <b>Renowned Quran Educator – </b>He has mentored thousands of
              students worldwide.
            </li>
            <li>
              <b>International Reach –</b> His teachings extend across multiple
              countries, impacting learners from Africa, the Middle East, and
              beyond.
            </li>
            <li>
              <b>Tajweed & Memorization Specialist –</b>He Helps students
              perfect their pronunciation, fluency, and memorization with
              structured guidance.
            </li>
          </ul>
          <p>
            Under his co-leadership, Maqrahaat ul Tanzeel has grown into a
            world-class institute, training the next generation of expert Quran
            reciters and memorizers.
          </p>
          <p>
            “The Quran is revealed in different modes of recitation, each
            carrying its own depth and beauty. Learning them all is a path to
            excellence in understanding and preserving the Divine message.” –
            Abu Malik Abdul Qudus
          </p>
          <a target="_blank" href="https://www.facebook.com/maqrahatultanzeel/">
            <Button
              btnText={"Connect with him on Facebook"}
              btnBgColor={
                "bg-[#66b2ff] hover:bg-white sm:rounded-full hover:rounded-full hover:border hover:border-[#333333]"
              }
              btnColor={"text-white hover:text-[#333333]"}
              padding={"px-5 py-2 transition-all  ease-in-out"}
            />
          </a>
        </div>
      </div>
    </>
  );
};

export default AboutFounder;
